import SurveyListingPage from './surveyListing.container'

export default SurveyListingPage